import { inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	ResolveFn,
	RouterStateSnapshot
} from '@angular/router';
import { Cluster } from '../../../definitions/clusters';
import { ClustersService } from '../components/services/clusters.service';

export const clusterResolver: ResolveFn<Cluster> = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const clustersSvc = inject(ClustersService);
	const clusterId = parseInt(route.paramMap.get('clusterId'));
	if (isNaN(clusterId)) {
		return null;
	}
	return clustersSvc.find(clusterId);
};
